import React, { useEffect, useState } from "react";
import { useMutation } from "@apollo/client";

import authManager from "../../lib/authManager";
import { Alert } from "../../components/Alert";
import { Input } from "../../components/Input";
import {
	GraphqlErrorMessage,
	ValidationErrorMessage,
} from "../../components/ErrorMessage";
import { Button, NakedButton } from "../../components/Button";
import { ColContainer } from "../../components/Container";

import { updateUserQuery } from "./queries";

const UserForm = ({ User, onSuccess }) => {
	const [updateUser, { loading, error: submitError }] = useMutation(updateUserQuery);

	const [form, setForm] = useState({
		name: "",
		email: "",
		phone: "",
	});

	const [initialForm, setInitialForm] = useState(form);
	const [errors, setErrors] = useState({});
	const [showSuccessMessage, setShowSuccessMessage] = useState(false);

	// populate from props
	useEffect(() => {
		if (User) {
			const userData = {
				name: User.name || "",
				email: User.email || "",
				phone: User.phone || "",
			};
			setForm(userData);
			setInitialForm(userData);
		}
	}, [User]);

	const isPristine =
		form.name === initialForm.name &&
		form.email === initialForm.email &&
		form.phone === initialForm.phone;

	const handleChange = (field) => (value) => {
		setShowSuccessMessage(false);

		setForm((prev) => ({
			...prev,
			[field]: value || "",
		}));
	};

	const validate = () => {
		const errs = {};
		if (!form.name) errs.name = "Please enter a name";
		if (!form.email) errs.email = "Please enter an email";
		return errs;
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		const validationErrors = validate();
		setErrors(validationErrors);

		if (Object.keys(validationErrors).length > 0) return;

		try {
			await updateUser({
				variables: {
					name: form.name,
					email: form.email,
					phone: form.phone,
					userId: authManager.userId,
				},
			});

			await onSuccess?.();

			setInitialForm(form);
			setShowSuccessMessage(true);
		} catch (err) {
			// handled by submitError
		}
	};

	const handleReset = () => {
		setForm(initialForm);
		setErrors({});
		setShowSuccessMessage(false);
	};

	return (
		<form onSubmit={handleSubmit}>
			{showSuccessMessage && (
				<Alert flavour="success">
					Your changes have been saved.
				</Alert>
			)}

			{submitError && <GraphqlErrorMessage error={submitError} />}
			{Object.keys(errors).length > 0 && <ValidationErrorMessage />}

			<ColContainer>
				<Input
					label="Name"
					value={form.name}
					onValueChange={handleChange("name")}
					autoFocus
					error={errors.name}
				/>
				<Input
					label="Email"
					value={form.email}
					onValueChange={handleChange("email")}
					error={errors.email}
				/>
				<Input
					label="Phone number"
					value={form.phone}
					onValueChange={handleChange("phone")}
				/>
			</ColContainer>

			<Button type="submit" disabled={loading || isPristine}>
				Update profile
			</Button>

			{!isPristine && (
				<NakedButton
					type="button"
					flavour="gray"
					disabled={loading}
					onClick={handleReset}
				>
					Cancel
				</NakedButton>
			)}
		</form>
	);
};

export default UserForm;